module.exports = {"name":"chromecastcaf","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.1.0","built":"2018-01-08","repo":"https://bitbucket.org/npaw/chromecastcaf-adapter-js","libVersion":"6.1.7","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getPlayrate","getDroppedFrames","getDuration","getBitrate","getThroughput","getRendition","getTitle","getIsLive","getResource"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 26
// module chunks = 0